import { Stack } from "@mantine/core";
import { type ForwardedRef, type ReactNode, forwardRef } from "react";

interface ReviewContainerProps {
  children: ReactNode;
}

const ReviewContainer = forwardRef(
  ({ children }: ReviewContainerProps, ref: ForwardedRef<HTMLDivElement>) => {
    return (
      <Stack
        ref={ref}
        className="review-shadow hover-scale rounded-xl bg-primary-default p-6 text-white shadow-amber-50"
        gap={"lg"}
      >
        {children}
      </Stack>
    );
  },
);

export default ReviewContainer;
